import ScrollToTopLink from "../../ScrollToTopLink";
import BuyButton from "../../buttons/BuyButton";
import ListenButton from "../../buttons/ListenButton";
import MoreButton from "../../buttons/MoreButton";

const Details = ({
  concert: { id, title, place, time, info_button, buy_link, lstn_link },
  t,
  isExpired,
}) => {
  return (
    <>
      <div className="service-desc-01">
        <h5>
          <ScrollToTopLink
            to={`/concerts/${id}`}
            className="special_hover text-capitalize"
          >
            {title}
          </ScrollToTopLink>
        </h5>

        <h6 className="uppercasebold2">{place}</h6>
        <h6 className="uppercasebold2">{time}</h6>

        {!isExpired && (
          <div
            className={`portfolio-meta${
              !(buy_link || lstn_link) ? " justify-content-center center-btn" : ""
            }`}
          >
            <div
              className={`meta-left${
                !(buy_link || lstn_link) ? " mx-auto text-center" : ""
              }`}
            >
              <MoreButton
                to={`/concerts/${id}`}
                text={t(`concerts.${info_button}`)}
              />
            </div>
            {(buy_link || lstn_link) && (
              <div className="meta-right">
                {buy_link && (
                  <BuyButton href={buy_link} text={t("concerts.buy_btn")} />
                )}
                {lstn_link && (
                  <ListenButton href={lstn_link} text={t("concerts.lstn_btn")} />
                )}
              </div>
            )}
          </div>
        )}

        {/* {lstn_link && (
          <div className="portfolio-meta">
            <div className="text-center">
              <ListenButton href={lstn_link} text={t("concerts.lstn_btn")} />
            </div>
          </div>
        )} */}
      </div>
    </>
  );
};

export default Details;
